import { useState } from 'react';
import cx from 'classnames';
import { Button, ButtonVariants } from '@components/button/Button';
import typography from '~styles/typography.scss';
import styles from './StaffNoteEditForm.scss';
import { Icon } from '@components/icon/Icon';

export interface StaffNoteEditFormOnSaveArgs {
  note: string | null;
}

export interface StaffNoteEditFormProps {
  note: string | null;
  onDiscard: () => void;
  onSave: (args: StaffNoteEditFormOnSaveArgs) => void;
  className?: string;
}

export const StaffNoteEditForm = ({
  note,
  onDiscard,
  onSave,
  className,
}: StaffNoteEditFormProps) => {
  const [newNote, setNewNote] = useState(note || '');

  return (
    <section
      aria-label="Edit staff note"
      className={cx(styles.container, className)}
    >
      <label htmlFor="staff-note">
        <h3 className={cx(typography.h7, styles.heading)}>
          <Icon name="file" /> Visit Notes
        </h3>
      </label>
      <textarea
        className={cx(typography.c2, styles.textarea)}
        defaultValue={note || ''}
        id="staff-note"
        onChange={(event) => setNewNote(event.target.value)}
        placeholder="Add Visit Notes"
      />
      <div className={styles.actions}>
        <Button
          label="Discard"
          onClick={onDiscard}
          variant={ButtonVariants.Default}
        />
        <Button
          label="Save"
          onClick={() => onSave({ note: newNote || null })}
          variant={ButtonVariants.Primary}
        />
      </div>
    </section>
  );
};
